import ApiService from "@/core/services/ApiService";
import JwtService from "@/core/services/JwtService";
import router from "@/router";
import { Actions, Mutations } from "@/store/enums/StoreEnums";
import { Module, Action, Mutation, VuexModule } from "vuex-module-decorators";



export interface Issue {
  id: number;
  description: string;
}


export interface IrbIssue {
  
  irbIssue;
}


@Module
export default class IrbIssuesModule
  extends VuexModule
  implements IrbIssue {
  irbIssue = {};
  irbIssues = [];
  

  /**
   * Get current applications
   * @returns Array<Application>
   */
  get currentIrbIssue() {
    console.log(this.irbIssue);
    return this.irbIssue;
  }

  get currentIrbIssues() {
    console.log(this.irbIssues);
    return this.irbIssues;
  }

  

  @Mutation
  [Mutations.SET_IRB_ISSUE](data) {
    this.irbIssue = data;
  }

  @Mutation
  [Mutations.SET_IRB_ISSUES](data) {
    this.irbIssues = data;
  }
  

  @Action
  [Actions.GET_IRB_APPLICATION_ISSUES](data) {
    return new Promise<void>((resolve, reject) => {
      if (JwtService.getToken()) {
        ApiService.setHeader();
        ApiService.query("irb/issues/list", data)
          .then(({ data }) => {
            this.context.commit(Mutations.SET_IRB_ISSUES, data);
            resolve();
          })
          .catch(({ response }) => {

            this.context.commit(Mutations.SET_IRB_ERROR, data);
            reject();
          });
      } else {
        this.context.commit(Mutations.SET_IRB_ERROR, {});
        reject();
      } 
    });
  }

  @Action
  [Actions.GET_IRB_APPLICATION_ISSUE](data) {
    return new Promise<void>((resolve, reject) => {
      if (JwtService.getToken()) {
        const url = 'irb/issues/' + data;
        ApiService.setHeader();
        ApiService.get(url)
          .then(({ data }) => {
            this.context.commit(Mutations.SET_IRB_ISSUE, data);
            resolve();
          })
          .catch(({ response }) => {

            this.context.commit(Mutations.SET_IRB_ERROR, data);
            reject();
          });
      } else {
        this.context.commit(Mutations.SET_IRB_ERROR, {});
        reject();
      } 
    });
  }

  @Action
  [Actions.POST_IRB_ISSUE](data) {
    return new Promise<void>((resolve, reject) => {
      if (JwtService.getToken()) {
        ApiService.setHeader();
        ApiService.post("irb/issues/create", data)
          .then(({ data }) => {
            this.context.commit(Mutations.SET_IRB_ISSUE, data);
            resolve();
          })
          .catch(({ response }) => {

            this.context.commit(Mutations.SET_IRB_ERROR, data);
            reject();
          });
      } else {
        this.context.commit(Mutations.SET_IRB_ERROR, {});
        reject();
      } 
    });
  }

  @Action
  [Actions.POST_IRB_ISSUE_UPDATE](data) {
    return new Promise<void>((resolve, reject) => {
      if (JwtService.getToken()) {
        ApiService.setHeader();
        ApiService.post("irb/issues/edit", data)
          .then(({ data }) => {
            this.context.commit(Mutations.SET_IRB_ISSUE, data);
            resolve();
          })
          .catch(({ response }) => {

            this.context.commit(Mutations.SET_IRB_ERROR, data);
            reject();
          });
      } else {
        this.context.commit(Mutations.SET_IRB_ERROR, {});
        reject();
      } 
    });
  }

}
